import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
];

const LanguageSwitcher = () => {
  const { lang, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setLanguage(code);
    setOpen(false);
  };

  return (
    <div
      className="lang-switcher nav-dropdown"
      ref={ref}
      onMouseEnter={() => window.innerWidth >= 992 && setOpen(true)}
      onMouseLeave={() => window.innerWidth >= 992 && setOpen(false)}
    >
      <button
        className="nav-link dropdown-trigger lang-trigger"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <i className="fas fa-globe" />
        <span>{current.label}</span>
        <i className={`fas fa-chevron-down dropdown-icon lang-chevron ${open ? 'rotate' : ''}`} />
      </button>
      <div className={`dropdown-menu lang-dropdown-menu ${open ? 'show' : ''}`} role="listbox">
        {LANGUAGES.map(l => (
          <button
            key={l.code}
            className={`dropdown-item lang-option ${l.code === lang ? 'active' : ''}`}
            onClick={() => handleSelect(l.code)}
            role="option"
            aria-selected={l.code === lang}
          >
            <span>{l.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
